import { useState, useEffect } from 'react'
import { KakaoMapService, type MapService, type Coordinates } from '@ablunch/map-service'

export const useMapService = (platform: 'kakao' | 'google' | 'naver' | 'apple' = 'kakao'): MapService | null => {
  const [mapService, setMapService] = useState<MapService | null>(null)

  useEffect(() => {
    let service: MapService | null = null

    switch (platform) {
      case 'kakao':
        service = new KakaoMapService({
          apiKey: import.meta.env.VITE_KAKAO_MAP_KEY
        })
        break
      // TODO: 다른 지도 서비스 추가
      default:
        console.warn(`Map platform ${platform} is not implemented yet`)
    }

    setMapService(service)
  }, [platform])

  return mapService
}

export const useCurrentLocation = () => {
  const [location, setLocation] = useState<Coordinates | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // HTTPS가 아닌 경우 테스트 위치 사용 (강남역)
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      console.warn('Geolocation requires HTTPS. Using test location.')
      setLocation({
        latitude: 37.4979,
        longitude: 127.0276
      })
      setLoading(false)
      return
    }

    if (!navigator.geolocation) {
      setError('Geolocation is not supported')
      setLoading(false)
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        })
        setLoading(false)
      },
      (error) => {
        setError(error.message)
        setLoading(false)
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    )
  }, [])

  return { location, error, loading }
}